import type { FC } from 'react'
import { useEffect } from 'react'

import { LoaderCircle } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import type { Notification } from '@/api/notifications'
import { notificationResources } from '@/api/notifications'
import queries from '@/api/queries'
import { useProfile } from '@/hooks/useProfile'
import { APP_ROUTES } from '@/util/appRoutes'

import { Translation } from '../i18n/Translation'
import { LoadingError } from '../LoadingError'

import { Activity } from './Activity'

export const Activities: FC = () => {
  const navigate = useNavigate()
  const { profile, isProfileLoading } = useProfile()

  useEffect(() => {
    if (Boolean(profile?.activitiesCount) === false && isProfileLoading === false) {
      navigate(APP_ROUTES.home)
    }
  }, [isProfileLoading, navigate, profile])

  if (isProfileLoading) {
    return (
      <div className="flex justify-center">
        <LoaderCircle />
      </div>
    )
  }

  const { data, isLoading, isError } = useQuery<Notification[]>(
    queries.notifications(),
    notificationResources.list,
    {
      enabled: Boolean(profile?.activitiesCount),
    }
  )

  if (isLoading) {
    return (
      <div className="flex justify-center">
        <LoaderCircle />
      </div>
    )
  }

  if (isError || !data) {
    return (
      <div className="flex justify-center">
        <LoadingError />
      </div>
    )
  }

  return (
    <>
      <div className="header mb-4 text-center text-xl">
        <Translation id="Activities" />
      </div>
      <div className="wrapper mx-auto w-full max-w-5xl pb-40">
        <div className="cards-container flex flex-wrap justify-start gap-4">
          {data.map((card, index) => (
            <Activity key={index} data={card} />
          ))}
        </div>
      </div>
    </>
  )
}
